/**
 * excel 文件工具类
 * @author tomxliu
 */
import { get, isFunction, cloneDeep } from 'lodash-es'
import { read as xlsxRead, utils as xlsxUtils, writeFile as xlsxWriteFile } from 'xlsx/dist/xlsx.mini.min'

export {
  xlsxRead,
  xlsxUtils,
  xlsxWriteFile
}

/**
 * 根据配置将表格数据转成XLSX文档所需格式
 * @param {*} tableData
 * @param {*} configs
 * @returns
 */
export const formatTableDataToXlsx = (tableData, configs) => {
  function formatRow(row, configs) {
    const result = {}
    for (const config of configs) {
      const { label, format, key, empty } = config

      if (empty) {
        result[label] = ''
        continue
      }

      const value = get(row, key) ?? ''
      if (format && isFunction(format)) {
        result[label] = format(value, row)
      } else {
        result[label] = value
      }
    }

    return result
  }

  const xlsxData = tableData.map(row => formatRow(row, configs))
  const options = configs.map(c => ({ width: c.width || 20 }))

  return { xlsxData, options }
}

/**
 * 通过 DOM 对象生成表格导出 excel 文件
 * @param {*} tableEl
 * @param {*} fileName
 * @param {*} workbookOpts
 * @param {*} ext
 */
export const exportTableByElement = (tableEl, fileName, workbookOpts = {}, ext = 'xlsx') => {
  const workbook = xlsxUtils.table_to_book(tableEl, workbookOpts)
  xlsxWriteFile(workbook, `${fileName || 'result'}.${ext}`)
}

/**
 * 通过列配置生成表格导出 excel 文件
 * @param {*} tableData
 * @param {*} columns 列配置
 * @param {*} fileName
 * @param {*} ext
 */
export const exportTableByColumn = (tableData, columns, fileName, ext = 'xlsx') => {
  if (!Array.isArray(tableData) || !tableData.length) {
    throw new Error('无可导出数据')
  }

  if (!Array.isArray(columns) || !columns.length) {
    throw new Error('导出配置不正确')
  }

  const workbook = {
    SheetNames: ['Sheet1'],
    Sheets: {
      Sheet1: {}
    },
    Props: {}
  }

  const { xlsxData, options } = formatTableDataToXlsx(cloneDeep(tableData), columns)
  const sheet = xlsxUtils.json_to_sheet(xlsxData)
  sheet['!cols'] = options
  workbook.Sheets.Sheet1 = sheet

  xlsxWriteFile(workbook, `${fileName || 'result'}.${ext}`)
}

/**
 * 使用xlsx库读取文件
 * @param {*} file
 * @returns
 */
export function readFileByXlsx(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result)
      const workbook = xlsxRead(data, { type: 'array' })
      const dataList = xlsxUtils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], { raw: false })

      resolve(dataList)
    }

    reader.onerror = reject

    reader.readAsArrayBuffer(file)
  })
}
